import {Injectable} from '@angular/core';
import {SecurityService} from "./security.service";
import {UserService} from "./user.service";

@Injectable({
    providedIn: 'root'
})
/**
 * Acl service to check user permission.
 */
export class AclService {

    constructor(private user: UserService) {
    }

    can(permission: any): boolean {
        const permisos = this.user.permissionList;
        const permisosList = permisos.split(' - ');
        //console.log("permisosList", permisosList);

        if(permission){
            //console.log("permission", permission);
            for (const permiso of permisosList) {
                // @ts-ignore
                if(permiso?.toLowerCase() == permission.toLowerCase()){
                    return true;
                }

            }
            return false;
        }

        return true;




    }

    canList(permissionList: any): boolean {
        const permisos = this.user.permissionList;
        const permisosList = permisos.split(' - ');

        if(permissionList && Array.isArray(permissionList)){
            for (const permiso of permisosList) {
                // @ts-ignore
                if(permissionList.indexOf(permiso.toLowerCase()) !== -1){
                    return true;
                }

            }

            return false;
        }

        return true;



    }
}
